interface NavigatorWithStandalone extends Navigator {
    standalone?: boolean;
}

export const isIOS = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    const toMatch = [/iPhone/i, /iPad/i, /iPod/i];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
};

export const isAndroid = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    const toMatch = [/Android/i];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
};

export const isOtherMobileDevice = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    const toMatch = [/webOS/i, /BlackBerry/i, /Windows Phone/i];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
};

export const isIOSApp = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    if (!isIOS()) {
        return false;
    }

    const userAgent = navigator.userAgent;
    const navWithStandalone = navigator as NavigatorWithStandalone;
    const isStandalone = navWithStandalone.standalone === true;

    const safariMatch = [/Safari/i];
    const nonSafariMatch = [/CriOS|FxiOS|EdgiOS/i];
    const isSafari =
        safariMatch.some((toMatchItem) => userAgent.match(toMatchItem)) &&
        !nonSafariMatch.some((toMatchItem) => userAgent.match(toMatchItem));

    const isWebView = !isSafari && !isStandalone;

    const knownWebViewMatch = [/WKWebView|WebView/i];
    const isKnownWebView = knownWebViewMatch.some((toMatchItem) => userAgent.match(toMatchItem));

    return isWebView || isKnownWebView;
};

export const isAndroidApp = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    if (!isAndroid()) {
        return false;
    }

    const userAgent = navigator.userAgent;
    const chromeMatch = [/Chrome/i];
    const isChrome = chromeMatch.some((toMatchItem) => userAgent.match(toMatchItem));

    const webViewMatch = [/wv|WebView/i];
    const isWebView = webViewMatch.some((toMatchItem) => userAgent.match(toMatchItem));

    return isWebView || (!isChrome && isAndroid());
};

export const isOtherDeviceApp = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    if (!isOtherMobileDevice()) {
        return false;
    }

    const userAgent = navigator.userAgent;
    const webViewMatch = [/WebView/i];
    const isWebView = webViewMatch.some((toMatchItem) => userAgent.match(toMatchItem));

    const browserMatch = [/Chrome|Safari|Firefox|Edge/i];
    const isEmbedded = !browserMatch.some((toMatchItem) => userAgent.match(toMatchItem));

    return isWebView || isEmbedded;
};

export const isShopApp = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    if (isIOSApp() || isAndroidApp() || isOtherDeviceApp()) {
        return true;
    }

    return false;
};
